<!--Author: Michał Pawłowski-->
<template>
  <nav>
    <CommonTable2
        :table="table"
        :rowIdentifier="rowIdentifier"
        :headerCheckboxClass="headerCheckboxClass"
        @onItemAction="runAction($event)"
        @onSort="sort($event)"
        @onMassAction="runMassAction($event)"
        @onCheckItem="checkAction($event)"
        :sortColumn="sortColumn"
        :sortDirection="sortDirection"
    />
  </nav>
</template>
<script>
import CommonTable2 from "./CommonTable2.vue";

export default {
  name: "ScrollableCommonTable",
  components: {CommonTable2},
  props: {table: Object, rowIdentifier: String,headerCheckboxClass: String},
  emits: ["onItemAction", "onSort", "onMassAction", "onCheckItem"],
  data() {
    return {
      sortColumn: '',
      sortDirection:'asc',
      list: [],
    };
  },
  methods: {
    runAction(event) {
      this.$emit("onItemAction", event);
    },
    sort(event) {
      this.$emit("onSort", event);
    },
    runMassAction(event) {
      this.$emit("onMassAction", event);
    },
    checkAction(event) {
      this.$emit("onCheckItem", event);
    },
  },
  watch: {

  },
  created() {

  },
};
</script>
<style scoped>
nav {
  height: 200px;
  width: 100%;
}
nav {
  overflow: hidden;
  overflow-y: scroll;
}

.internal-placement {
  padding: 15px;
  background-color: #f5f5dc52;
}
</style>
